import React from "react";

const items = ["Discretion", "Precision", "Trust", "White-Glove Care", "Peace of Mind", "Timeless Elegance"];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section className="py-16 md:py-20 bg-forest overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-warmwhite/90 text-4xl md:text-6xl font-light px-8 md:px-12">
              {t}
            </span>
            <span className="text-champagne text-2xl md:text-3xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
